import { Directive } from '@angular/core';
import { IfSagepayCloudPaymentActiveDirectiveDef } from './if-sagepay-cloud-payment-active.directive.def';

@Directive()
export abstract class IfNotSagepayCloudPaymentActiveDirectiveDef extends IfSagepayCloudPaymentActiveDirectiveDef {
    protected getValue(): boolean {
        return !super.getValue();
    }
}